<template>
  <v-toolbar>
    <v-spacer></v-spacer>
    <v-text-field
      v-model="search"
      append-icon="search"
      :label="$vuetify.t('$vuetify.AdminUsers.searchLabel')"
      single-line
      hide-details
    ></v-text-field>
  </v-toolbar>
</template>

<script>
export default {
  name: 'TableSearchBar',
  data: function () {
    return {
      search: ''
    }
  },
  watch: {
    search: function () {
      this.$emit('changed', this.search)
    }
  }
}
</script>

<style scoped>

</style>
